/**
 * Per-class color palettes for VFX consistency.
 *
 * Use these constants when creating new VFX effects, projectiles, or
 * ability visuals to keep each class's visual identity cohesive.
 */

export const VFX_PALETTE = {
  hunter: {
    primary: 0xD4A574,   // Warm golden-brown (arrows, auto-attack)
    accent: 0xFFD700,    // Gold (piercing shot, power abilities)
    trail: 0xFFEECC,     // Pale gold (tip sparks, highlights)
    secondary: 0xCD853F, // Tan (spread shot, multi-arrows)
    nature: 0x228B22,    // Forest green (class identity)
    poison: 0x00FF00,    // Bright green (poison abilities)
    poisonDark: 0x006600, // Dark green (poison spores)
  },

  warrior: {
    primary: 0xFF0000,   // Red (charge, battle cry)
    accent: 0xFF4444,    // Light red (embers, secondary effects)
    steel: 0xCCCCCC,     // Silver (blade effects, metal)
    steelDark: 0x888888, // Dark silver (blade streaks)
    dust: 0xBBAA88,      // Tan-brown (ground dust, debris)
    earth: 0x886644,     // Brown (ground slam debris)
  },

  mage: {
    fire: 0xFF4500,      // Orange-red (fireball)
    frost: 0x00FFFF,     // Cyan (frost bolt, ice)
    frostLight: 0xADD8E6, // Light blue (frost accents)
    arcane: 0xAA00FF,    // Purple (arcane barrage, arcane bolt)
    arcaneLight: 0xCC66FF, // Light purple (arcane scatter)
    mana: 0x4488FF,      // Blue (mana shield)
  },

  paladin: {
    holy: 0xFFD700,      // Gold (primary holy effects)
    holyBright: 0xFFFF00, // Bright yellow (shield stroke, stars)
    holyWhite: 0xFFFFFF, // White (judgment beam, flashes)
    heal: 0x00FF00,      // Green (healing effects)
    healGold: 0xFFDD44,  // Yellow-gold (heal motes)
    fire: 0xFF4500,      // Orange-red (holy fire)
  },

  rogue: {
    shadow: 0x8800FF,    // Purple (blink, shadow effects)
    shadowDark: 0x6600CC, // Dark purple (fragments)
    shadowDeep: 0x330066, // Very dark purple (wisps)
    stealth: 0x663399,   // Muted purple (dark sight aura)
    speed: 0x00FFFF,     // Cyan (haste, blink destination)
    metal: 0x808080,     // Gray (throwing stars)
  },

  common: {
    white: 0xFFFFFF,
    whiteWarm: 0xFFEECC,
    damage: 0xFF3333,
    critical: 0xFFAA00,
    heal: 0x00FF00,
    xp: 0x00FFFF,
  },
} as const;
